import { render } from "./cadastro_kits.vue?vue&type=template&id=6642eb6a"
import script from "./cadastro_kits.vue?vue&type=script&lang=js"
export * from "./cadastro_kits.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__